<template lang="pug">
include /mixins.pug

+b.info-block
  +e.title
    +b.P.ds-caption.--size_2md.--size_4md-sm.--color_main-dark.--medium {{ $t('Настройки аккаунта') }}
  +e.content
    info-label.is-flex-xl
    +b.g-row.--appearance_spaced.--appearance_reverse-till-xl.--space_1xl-xl
      +b.g-cell.g-cols--12.--9-xl
        info-label.is-disable-xl
        VeeForm(v-slot="{ errors }", @submit="request")
          VeeError(name="nonFieldErrors" v-slot="{ message }"): +b.simple-errors {{ message }}
          +b.g-row.--space_1xl-md
            +b.g-cell.g-cols--12.--6-sm.ec-space_mt--2
              DController(
                :name="'firstName'"
                v-model="formdata.firstName"
                :errors='errors'
                :static-label=`$t("Имя")`
                :placeholder=`$t("Введите ваше имя")`
                rules="required|onlyEnglish|alpha|max:30"
              )
            +b.g-cell.g-cols--12.--6-sm.ec-space_mt--2
              DController(
                :name="'lastName'"
                v-model="formdata.lastName"
                :errors='errors'
                :static-label=`$t("Фамилия")`
                :placeholder=`$t("Введите вашу фамилию")`
                rules="required|onlyEnglish|alpha"
              )
            +b.g-cell.g-cols--12.--6-sm.ec-space_mt--2
              DController(
                :name="'phoneNumber'"
                v-model="formdata.phoneNumber"
                :errors='errors'
                :static-label=`$t("Телефон")`
                readonly
              )
            +b.g-cell.g-cols--12.--6-sm.ec-space_mt--2
              DController(
                :name="'email'"
                v-model="formdata.email"
                :errors='errors'
                :static-label=`$t("E-mail")`
                :placeholder=`$t("Введите вашу почту")`
                :type="'email'"
                rules="required|email"
              )
            +b.g-cell.g-cols--12.--6-sm.ec-space_mt--2
              DController(
                :name="'whatsappLink'"
                v-model="formdata.whatsappLink"
                :placeholder=`$t("https://wa.me/number")`
                :errors='errors'
                :static-label=`$t("Ссылка на Whatsapp")`
                rules="isWhatsApp"
              )
            +b.g-cell.g-cols--12.--6-sm.ec-space_mt--2
              DController(
                :class="'d-control-descriptor--h_default'"
                :component="'Multiselect'"
                :name="'country'"
                :searchable="true"
                :allow-empty='false'
                :static-label=`$t("Страна")`
                :placeholder=`$t("Выбор")`
                :options="options.countries"
                v-model="formdata.country"
                track-by="slug"
                :labelBy="'label'"
                rules="required"
                @update:model-value="updateAfterSearch($event, 'country')"
              )
                template(#noResult)
            +b.g-cell.g-cols--12.--6-sm.ec-space_mt--2
              DController(
                :class="'d-control-descriptor--h_default'"
                :component="'Multiselect'"
                :name="'category'"
                :allow-empty='false'
                :static-label=`$t("Категория")`
                :options="options.categories"
                v-model="formdata.category"
                track-by="slug"
                :labelBy="'label'"
                rules="required"
                @update:model-value="updateVal($event, 'category')"
              )
            +b.g-cell.g-cols--12.--6-sm.ec-space_mt--2
              DController(
                :class="'d-control-descriptor--h_default'"
                :component="'Multiselect'"
                :name="'subcategories'"
                :allow-empty='false'
                :static-label=`$t("Подкатегория")`
                :options="options.subcategories"
                v-model="formdata.subcategories"
                track-by="slug"
                rules="required"
                :multiple="true"
                :labelBy="'label'"
              )
                template(#selection)
                template(#noOptions)
            +b.g-cell.g-cols--12.--6-sm.ec-space_mt--2
              DController(
                :class="'d-control-descriptor--h_default'"
                :component="'Multiselect'"
                :name="'studentAges'"
                :static-label=`$t("Возраст учеников")`
                :options="options.studentAges"
                v-model="formdata.studentAges"
                track-by="slug"
                :multiple="true"
                :labelBy="'label'"
              )
                template(#selection)
            +b.g-cell.g-cols--12.--6-sm.ec-space_mt--2
              DController(
                :name="'password'"
                :value="'********'"
                :errors='errors'
                :static-label=`$t("Пароль")`
                readonly
              )
            +b.g-cell.g-cols--12.--6-sm.--narrow-md.ec-space_mt--7
              +b.BUTTON.link-button.--style_main.--color_pink.--hover_blue.--full-size(
                :disabled='isLoad || isCanNotUpdate'
                type='submit'
              )
                +b.SPAN.ds-caption.--color_main-white.--size_sm.--size_md-lg.--semibold {{ $t('Сохранить настройки') }}
            +b.g-cell.g-cols--12.--6-sm.--narrow-md.ec-space_mt--7
              +b.BUTTON.link-button.--style_main.--br_pink.--hover_pink.--full-size(
                @click.prevent="useModalOpener({ component: 'Forms/ChangePassword' })"
                :disabled="isCanNotUpdate"
              )
                +b.SPAN.ds-caption.--color_inherit.--size_sm.--size_md-lg.--semibold {{ $t('Изменить пароль') }}

      +b.g-cell.g-cols--12.--3-xl
        avatar-info(
          :avatar="formdata.avatar"
          @avatar:update="formdata.avatar = $event, request()"
          :is-can-not-update="isCanNotUpdate"
        )

</template>

<script setup>
/* eslint-disable */
import { defineProps, ref, reactive, onMounted, nextTick } from 'vue'
import {
  profileResource,
  profileUpdate,
  profileChoicesResource,
  childsChoicesResource,
} from '@services/teacher.service'
import { clone } from 'ramda'
import { useModalOpener } from '@/composables/useModalOpener'
import { useSubmit } from '@/components/Forms/FormMixin'
import useMethods from '../Common/utils'

const props = defineProps({
  isCanNotUpdate: Boolean,
})

const { prepareData } = useMethods()

const isLoad = ref(false)

let formdata = reactive({
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  whatsappLink: '',
  country: [],
  category: [],
  subcategories: [],
  studentAges: [],
})

let options = reactive({
  countries: [],
  categories: [],
  subcategories: [],
  studentAges: [],
})

const request = (sendData, control) => {
  isLoad.value = true
  useSubmit(send(sendData), control)
}

const send = async() => {
  const clonedData = clone(formdata)
  const sendData = prepareData(clonedData)
  try {
    await profileUpdate.execute({}, sendData)
    window.location.reload()
    isLoad.value = false
  } catch (e) {
    isLoad.value = false
    return Promise.reject(e)
  }
}

const updateAfterSearch = async (val, key) => {
  if (val?.slug) {
    await nextTick()
    formdata[key] = val
  } else {
    formdata[key] = []
  }
}

const updateVal = (data, key) => {
  formdata[key] = data
  formdata.subcategories = []
  getChildChoices(data.slug)
}

const getChildChoices = async parent => {
  try {
    const { data: { items } } = (await childsChoicesResource.execute({ parent }))
    await nextTick()
    options.subcategories = items
  } catch (e) {
    console.error(e, 'Error')
  }
}

const getChoices = async() => {
  try {
    const { data: { item } } = (await profileChoicesResource.execute({}))
    await nextTick()
    Object.assign(options, { ...item })
  } catch (e) {
    console.error(e, 'Error')
  }
}

const getProfileInfo = async() => {
  try {
    const { data: { item } } = (await profileResource.execute({}))
    await nextTick()
    Object.assign(formdata, { ...item })
    getChildChoices(formdata.category.slug)
  } catch (e) {
    console.error(e, 'Error')
  }
}

onMounted(async() => {
  await getChoices()
  getProfileInfo()
})

</script>
